import BacnetObjects from "./BacnetObjects";

const BacnetObjectsRead = () => <BacnetObjects mode="read" />

export default BacnetObjectsRead;